<template>
  <b-table
      :fields="fields"
      :items="items"
      @row-clicked="onClickRow"
      table-class="text-nowrap"
      responsive
      hover
  >
    <template #cell(title)="data">
      <h4 class="mb-0">
        <b-icon-star-fill v-if="data.item.listing.is_promoted" title="Featured Listing"/>
        {{ data.item.title }}
      </h4>
    </template>
    <template #cell(bids)="data">
      Current Bid: {{ data.item.current_bid }}
      <br>
      Total Bids: {{ data.item.listing.bids_count }}
    </template>
    <template #cell(status)="data">
      <admin-listing-status-badge :listing="data.item.listing"/>
    </template>
  </b-table>
</template>

<script>
import AdminListingStatusBadge from "./AdminListingStatusBadge";
import {getFormattedPrice} from "../helpers";
export default {
  name: "AdminListingsTable",
  components: {AdminListingStatusBadge},
  props: {
    listings: {
      type: Array,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    items() {
      return this.listings.map(listing => {
        return {
          listing: listing,
          title: listing.title,
          inventory: listing.inventory_value + ' ' + listing.inventory_unit,
          company: listing.company.name,
          brand: listing.brand.name,
          current_bid: getFormattedPrice(listing.current_bid),
          category: listing.category_type.name + ' (' + listing.category.name + ')',
          strain: listing.strain_type?.name,
          production: listing.production_type?.name
        }
      });
    },
    fields() {
      let fields = [
        {
          key: "title",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "inventory",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "company",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "brand",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "bids",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "status",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "category",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "strain",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "production",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
      ];
      if (this.small) {
        fields = [
          {
            key: "title",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          },
          {
            key: "inventory",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          },
          {
            key: "bids",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          },
          {
            key: "status",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          }
        ];
      }

      return fields;
    }
  },
  methods: {
    onClickRow(item) {
      let listingId = item.listing.id;
      this.$router.push({name: "admin-listing", params: {id: listingId.toString()}});
    }
  }
}
</script>
